export const CREATE_VEHICLE  = 'CREATE_VEHICLE';
export const GET_VEHICLE  = 'GET_VEHICLE';
export const VEHICLE_REQUEST  = 'VEHICLE_REQUEST';
export const DELETE_VEHICLE  = 'DELETE_VEHICLE';
export const UPDATE_VEHICLE  = 'UPDATE_VEHICLE';
export const VEHICLE_REQUEST_FAILURE  = 'VEHICLE_REQUEST_FAILURE';